// extracted by mini-css-extract-plugin
module.exports = {"list":"nav-list-NavList-list-48bd256d"};